/* eslint-disable */
// @ts-nocheck
import React, { useEffect } from 'react';
import cl from 'classnames';
import moment, { Moment } from 'moment';
import { Carousel, Tabs, Button, Input, Dropdown, Menu, Space, Progress, Tooltip } from 'antd';
// import { useAsyncFn } from 'react-use';
import { isArray, isEmpty } from 'lodash';
// import { post, get } from '@/utils/request';
import {
  DownOutlined,
  SwapOutlined,
  RightOutlined,
  InfoCircleOutlined,
  MobileOutlined,
} from '@ant-design/icons';
// import { useAppSelector } from '@/app/hooks';
// import IconFont from '@/components/Iconfont';
import { Icon } from '@digitalc/dxp-ui';
import { HexToRGB, shouldShowImage, appUrlJump, formatPhoneSegment } from '@/utils/utils';
import moreImg from '@/assets/images/ic_home_more.svg';
import singleBg from '@/assets/images/ic_bg_assembly.svg';
import styles from '../../index.less';
import headerStyles from './index.less';

const NewToolbar = ({
  visible,
  pictures: _pictures,
  hasLogo,
  hasSidebar,
  title,
  showDivider,
  logoInfo,
  sidebarInfo,
  titleFontSize,
  titleFontColor,
  titleFontColorOpacity,
  isTitleFontBold,
  isTitleFontItalic,
  iconFontColor,
  iconFontColorOpacity,
  isIconFontBold,
  isIconFontItalic,
  position,
  hasBackground,
  topMargin,
  bottomMargin,
  horizontalOutterMargin,
  topPadding,
  bottomPadding,
  horizontalInnerPadding,
  greetingsInfo,
  fullNameDisplay,
  isTitleFontUnderline,
  accountSize,
  accountFontColor,
  accountFontColorOpacity,
  isAccountFontBold,
  isAccountFontItalic,
  isAccountFontUnderline,
  hasBack,
  backInfo,
  hasGrettings,
  hasAccount,
  accountInfo,
  bgStyle,
  fixedBgType, // bg的类型:Color | Image
  fixedBgImg,
  fixedBgColor,
  fixedBgOpacity,
  customBgList,
  eLoginTheme,
  isEmailLogin,
}) => {
  const localState = localStorage.getItem('currState');
  const settingState = localStorage.getItem('settingModal');
  const prevState = localStorage.getItem('currPrevState');
  const pictures = (_pictures || []).filter(it => it.visible !== false);
  // 获取projectCode - 必须在组件顶层调用hooks
  // const newPageInfo: any = useAppSelector((state) => state?.newPageInfo) || {};
  // const projectCode = newPageInfo?.projectCode || '';
  const initAppStr = window.localStorage.getItem('initApp');
  const initApp = JSON.parse(initAppStr) || {};

  let iconsLength = pictures?.length > 3 ? 3 : pictures?.length;
  if (hasSidebar === 'Y') {
    iconsLength = iconsLength + 1;
  }
  if (hasBack === 'Y') {
    iconsLength = iconsLength + 1;
  }

  // const [, qryMembershipList] = useAsyncFn(async (data: any) => {
  //   const res: any = await post({
  //     url: `${getWebRootNew()}/promotion/membership/get-level-list-by-condition`,
  //     data,
  //   });
  //   return res.data;
  // }, []);

  const getBgStyle = () => {
    const obj = {};
    if (hasBackground === 'Y') {
      if (bgStyle === 'fixed') {
        if (fixedBgType === 'Color') {
          obj.backgroundColor = HexToRGB(fixedBgColor, fixedBgOpacity);
        } else {
          obj.backgroundImage = `url(${fixedBgImg?.src})`;
          obj.backgroundSize = 'cover';
          obj.backgroundRepeat = 'no-repeat';
          obj.backgroundPosition = 'center';
        }
      } else {
        const currentObj = customBgList?.[0] || {};
        if (currentObj.bgType === 'Color') {
          obj.backgroundColor = HexToRGB(currentObj.color, currentObj.opacity);
        } else {
          obj.backgroundImage = `url(${currentObj.bgImg?.src})`;
          obj.backgroundSize = 'cover';
          obj.backgroundRepeat = 'no-repeat';
          obj.backgroundPosition = 'center';
        }
      }
    } else {
      obj.background = 'initial';
    }
    const st = {
      ...obj,
      marginTop: `${topMargin}px`,
      marginBottom: `${bottomMargin}px`,
      marginLeft: `${Number(horizontalOutterMargin || 0)}px`,
      marginRight: `${Number(horizontalOutterMargin || 0)}px`,
      paddingLeft: `${Number(horizontalInnerPadding || 0)}px`,
      paddingRight: `${Number(horizontalInnerPadding || 0)}px`,
      paddingTop: `${topPadding}px`,
      paddingBottom: `${bottomPadding}px`,
      // justifyContent: position,
    };
    return st;
  };

  const nameStyles = {
    color: HexToRGB(iconFontColor, iconFontColorOpacity),
    fontWeight: isIconFontBold === 'Y' ? 'bold' : 'normal',
    fontStyle: isIconFontItalic === 'Y' ? 'italic' : 'normal',
    textDecoration: isTitleFontUnderline === 'Y' ? 'underline' : '',
  };
  const handleAppUrlJump = (url, schemaType = '') => {
    appUrlJump(url, Number(schemaType) === 1 || Number(schemaType) === 5);
  };
  const getMenu = () => {
    return (
      <Menu className={styles.toolbarMenu}>
        {(pictures.slice(0).splice(2) || []).map((item, index) => (
          <Menu.Item key={index}>
            {shouldShowImage(item.src) && (
              <img className={styles.toolbarImg} src={item.src} alt="" />
            )}
            <span className={styles.name}>{item.iconName}</span>
          </Menu.Item>
        ))}
      </Menu>
    );
  };

  const getImgWrap = (info, key, className) =>
    shouldShowImage(info?.src) && (
      <img
        className={className}
        key={key}
        src={info?.src}
        alt=""
        onClick={() => handleAppUrlJump(info?.link, info?.linkType)}
        style={{ height: `${info?.height / 2 || 24}px`, width: `${info?.width / 2 || 24}px` }}
      />
    );

  const renderIcon = () => {
    // 如果pictures.length >= 5则全部放在...之中
    if (pictures.length > 3) {
      const lastestPicList = pictures.slice(0, 2);
      return (
        <div className={styles.innerMoreBox} style={{ marginLeft: '4px' }}>
          <div>{lastestPicList.map((item, index) => getImgWrap(item, index, styles.myIcon))}</div>
          <Dropdown overlay={getMenu()} trigger={['click']} placement="bottomRight">
            <a onClick={e => e.preventDefault()}>
              <Space>
                {shouldShowImage(moreImg) && <img style={{ marginLeft: 4 }} src={moreImg} alt="" />}
              </Space>
            </a>
          </Dropdown>
        </div>
      );
    }
    return (
      <div className={styles.innerIconBox}>
        {(pictures || []).map((item, index) => getImgWrap(item, index, styles.myIcon))}
      </div>
    );
  };

  const titleStyle = {
    fontSize: `${titleFontSize}px`,
    color: HexToRGB(titleFontColor, titleFontColorOpacity),
    fontWeight: isTitleFontBold === 'Y' ? 'bold' : 'normal',
    fontStyle: isTitleFontItalic === 'Y' ? 'italic' : 'normal',
    textDecoration: isTitleFontUnderline === 'Y' ? 'underline' : '',
    display: 'flex',
    justifyContent: position,
    width: '100%',
    alignItems: 'center',
    lineHeight: 1.1,
    padding: '4px 0',
    wordBreak: 'break-word',
  };

  const accountStyle = {
    fontSize: `${accountSize}px`,
    color: HexToRGB(accountFontColor, accountFontColorOpacity),
    fontWeight: isAccountFontBold === 'Y' ? 'bold' : 'normal',
    fontStyle: isAccountFontItalic === 'Y' ? 'italic' : 'normal',
    textDecoration: isAccountFontUnderline === 'Y' ? 'underline' : '',
    display: 'flex',
    justifyContent: 'left',
    width: '100%',
    alignItems: 'center',
    lineHeight: 1,
  };

  const toolStyle = {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
  };

  const renderEmailLogin = () => {
    if (isEmailLogin) {
      return (
        <div
          className={headerStyles.emailLogin}
          style={{ color: eLoginTheme === 'white' ? '#fff' : '#222' }}
        >
          <Icon
            type="icon-Tack-1"
            style={{
              fontSize: '18px',
              marginRight: '4px',
              color: eLoginTheme === 'white' ? '#fff' : '#222',
            }}
          />
          <span className={headerStyles.content}>
            Managing multiple lines?{' '}
            <span
              className={headerStyles.loginWarp}
              style={{ color: eLoginTheme === 'white' ? '#E5FF17' : '#1800E7' }}
            >
              Log in{' '}
            </span>
            via email
          </span>
        </div>
      );
    }
    return null;
  };

  return (
    <div
      className={cl(
        { hidden: !visible },
        showDivider && headerStyles.showDivider,
        localState === '0' || prevState === 'Y' || settingState === 'Y' ? styles.previewBox : null,
      )}
    >
      <div style={getBgStyle()}>
        <div className={cl(styles.newToolbarInnerBox, styles.myNewToolbar)}>
          <div style={toolStyle}>
            <div
              className={styles.innerLeft}
              style={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                flex: 1,
              }}
            >
              {hasBack === 'Y' && getImgWrap(backInfo?.[0])}
              {hasSidebar === 'Y' && getImgWrap(sidebarInfo?.[0])}
              {hasLogo === 'Y' && shouldShowImage(logoInfo?.[0]?.src) && (
                <img style={{ height: '24px' }} src={logoInfo?.[0]?.src} alt="" />
              )}
              {hasLogo !== 'Y' && iconsLength < 3 && isEmailLogin && renderEmailLogin()}
              {hasLogo !== 'Y' && iconsLength < 3 && !isEmailLogin && hasGrettings === 'Y' && (
                <div style={titleStyle}>{greetingsInfo?.fixedText}</div>
              )}
              {hasLogo !== 'Y' &&
                iconsLength <= 4 &&
                !isEmailLogin &&
                hasGrettings !== 'Y' &&
                hasAccount === 'Y' && (
                  <div style={accountStyle}>
                    {formatPhoneSegment(initApp.displayPhone || initApp.mobile)}
                    {shouldShowImage(accountInfo?.[0]?.src) && (
                      <img
                        style={{ height: '16px', marginLeft: '4px' }}
                        src={accountInfo?.[0]?.src}
                        alt=""
                      />
                    )}
                  </div>
                )}
            </div>
            <div className={styles.innerRight}>{renderIcon()}</div>
          </div>
        </div>
        {isEmailLogin &&
          (hasLogo === 'Y' || (hasLogo !== 'Y' && iconsLength >= 3)) &&
          renderEmailLogin()}
        {hasGrettings === 'Y' &&
          (hasLogo === 'Y' || (hasLogo !== 'Y' && iconsLength >= 3) || isEmailLogin) && (
            <div style={titleStyle}>{greetingsInfo?.fixedText}</div>
          )}
        {hasAccount === 'Y' &&
          (hasGrettings === 'Y' ||
            (hasLogo !== 'Y' && iconsLength > 4) ||
            hasLogo === 'Y' ||
            isEmailLogin) && (
            <div style={accountStyle}>
              {formatPhoneSegment(initApp.displayPhone || initApp.mobile)}
              {shouldShowImage(accountInfo?.[0]?.src) && (
                <img
                  style={{ height: '16px', marginLeft: '4px' }}
                  src={accountInfo?.[0]?.src}
                  alt=""
                />
              )}
            </div>
          )}
      </div>
    </div>
  );
};
export default NewToolbar;
